export = [
{
    "angle": 0,
    "xoffset": 0,
    "yoffset": 0,
    "type": "esriPMS",
    "url": "https://rawgit.com/mapbox/maki/master/icons/aerialway-11.svg",
    "width": 30,
    "height": 30
}
];